import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { scrollToSection } from "../utils/scroll";

export default function FooterSection() {
  return (
    <footer data-testid="main-page-footer" className="relative border-t border-white/10 bg-[#040910] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <img
                src="/images/logo.png"
                alt="the coolpool company GmbH"
                className="h-11 w-auto notranslate"
                translate="no"
              />
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
              Wasser und Technik perfekt vereint. Exklusiver Poolbau, intelligente Schwimmbadtechnik und
              kristallklare Wasserqualität — alles aus einem Haus.
            </p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.24em] font-mono text-slate-500 font-semibold">Navigation</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                ["Technik", "#technik"],
                ["Über uns", "#story"],
                ["Konfigurator", "#konfigurator"],
                ["Kontakt", "#kontakt"],
              ].map(([label, target]) => (
                <li key={target}>
                  <button
                    data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                    onClick={() => scrollToSection(target)}
                    className="text-slate-300 hover:text-cyan-300 transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.24em] font-mono text-slate-500 font-semibold">Rechtliches</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link data-testid="footer-link-impressum" to="/impressum" className="text-slate-300 hover:text-cyan-300 transition-colors">
                  Impressum
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-datenschutz" to="/datenschutz" className="text-slate-300 hover:text-cyan-300 transition-colors">
                  Datenschutz
                </Link>
              </li>
            </ul>
            <div className="mt-6 rounded-xl border border-cyan-400/20 bg-cyan-400/5 p-4 text-xs text-slate-400 leading-relaxed">
              <strong className="text-cyan-300">Notdienst:</strong> Für Bestandskunden rund um die Uhr erreichbar.
            </div>
          </div>
        </div>
      </div>

      <div className="relative select-none pointer-events-none" aria-hidden="true">
        <p className="text-outline font-display font-extrabold text-center whitespace-nowrap leading-none text-[16vw] tracking-tight -mb-[3vw] notranslate" translate="no">
          COOLPOOL
        </p>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500 notranslate" translate="no">© {new Date().getFullYear()} <span className="text-slate-300">the </span><span className="text-cyan-400">coolpool</span><span className="text-slate-300"> company GmbH</span> · Wasser und Technik perfekt vereint</p>
          <button
            data-testid="footer-back-to-top-button"
            onClick={() => window.__lenis?.scrollTo(0, { duration: 1.6 })}
            className="inline-flex items-center gap-2 text-xs text-slate-400 hover:text-cyan-300 transition-colors"
          >
            Nach oben <ArrowUp className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </footer>
  );
}
